/* eslint-disable no-inline-comments */

import { getWithSSRSupport } from '../helpers';
import axios from '../http-client';
import env from '@y2/environments';
import type { RangeOptions } from './realestate-search-options';

type Address = {
  city?: {
    text: string;
  };
  street: {
    text: string;
  };
  houseNumber: number;
  addressMasterId: number;
};

export type CompletedDeal = {
  price: number;
  address: Address;
  buildYear: number;
  rooms: number;
  floor: number;
  buildingMR: number;
  numberOfFloors: number;
  propertyType: string;
  saleDate: string /** format ISO-8601 @see https://en.wikipedia.org/wiki/ISO_8601 */;
};

export type CompletedDealsQuery = {
  // pagination
  limit?: number;
  page?: number;
  // sort
  sortBy?: string;
  order?: string;
  // address
  topArea?: number;
  area?: number;
  city?: string;
  neighborhood?: number;
  street?: string;
  coords?: string;
  // rooms range filter
  minRooms?: number;
  maxRooms?: number;
  // sale year range filter
  minSaleYear?: number;
  maxSaleYear?: number;
  propertyType?: string;
};

export type CompletedDealCountQuery = {
  city?: string;
  neighborhood?: number;
};

export type CompletedDealsResponse = {
  data: {
    results: CompletedDeal[];
    pagination: {
      total: number;
      totalPages: number;
      page: number;
    };
  };
};

type SearchOptionsResponse = {
  data: {
    saleYearRange: {
      from: number;
      to: number;
    };
    roomsRange: RangeOptions;
  };
};

export type DealCountResponse = {
  data: {
    cityId: string;
    countDeals: number;
    percentageChange: number;
  };
};

/**
 * client for `latest-deals-completed` service
 * @see https://gw.yad2.io/latest-deals-completed/api-docs/
 */
export const createLatestDealsCompletedClient = () => {
  const client = axios.create({
    baseURL: getWithSSRSupport(env.routes.api.gw, 'latest-deals-completed'),
  });

  return {
    get: (query: CompletedDealsQuery) =>
      client.get<CompletedDealsResponse>(`/`, { params: query }),
    searchOptions: () => client.get<SearchOptionsResponse>('/search-options'),
    dealCount: (query: CompletedDealCountQuery) =>
      client.get<DealCountResponse>('/deal-count', { params: query }),
  };
};
